const getExtensionAccessFromDefinition = extensionDefinition => {
  return extensionDefinition ? {
    accessible: false,
    actionCardContent: extensionDefinition.actionCardContent,
    actionDescription: extensionDefinition.actionDescription,
    actionName: extensionDefinition.actionName,
    actionShortDescription: extensionDefinition.actionShortDescription,
    actionTypeId: extensionDefinition.actionTypeId,
    accessLevel: 'USER_ACCESS',
    lifecycleStage: extensionDefinition.lifecycleStage,
    listingCategory: 'listingCategory' in extensionDefinition ? extensionDefinition.listingCategory : null,
    metaType: extensionDefinition.metaType
  } : undefined;
};
export default getExtensionAccessFromDefinition;